export default __webpack_public_path__ + "static/media/p05 p02.06681b4e.jpg";